import i18n from "i18n";

export const getOffers = () => [];
